type BtnLoaderProps = {
    loading: boolean,
    onClick?: (e:any) => void
    children?: React.ReactNode
}
export const BtnLoader: React.FC<BtnLoaderProps> = (props) => {
    return <button className='btn btn-primary me-2' disabled={props.loading} onClick={props.onClick}>
    {!props.loading && props.children ? props.children : ""}
    {props.loading && (
        <span className='indicator-progress' style={{ display: 'block' }}>
            Please wait...
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
        </span>
    )}
</button>
}